import {
  DETAIL_TAB,
  DETAIL_TAB2POINT_CLOUD_TYPE,
  EDialogType,
  EViewerMode,
  IEnabledUpdateProjectDetail,
  PollingContext,
  ProcessIds,
  ProjectDetailContext,
  UseSnackbarContext,
} from "../../../pages/ProjectDetail";
import { Q3DButton } from "../../Parts/Q3DButton";
import { Q3DTabPanel } from "../../Parts/Q3DTabPanel";

import ReplyIcon from "@mui/icons-material/Reply";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import RestoreIcon from "@mui/icons-material/Restore";
import Save from "@mui/icons-material/Save";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useRef, useState } from "react";
import { ISelectionData } from "../../../viewer/Canvas/polygon-selection";
import { Common } from "../../../../common/src";
import { config } from "../../../config/config";
import {
  DialogTitle,
  DialogActions,
  Checkbox,
  Dialog,
  Button,
  styled,
  useTheme,
} from "@mui/material";
import axios from "axios";
import FormatUtil from "../../Utility/ProjectComUtil";
import { useParams } from "react-router-dom";
import Q3DIconButton from "../../Parts/Q3DIconButton";
import RemoveContext from "../Contexts/RemoveContext";

type Props = {
  width?: string;
};

interface PollingIds {
  sfm: number;
  helmert: number;
}

const enum ERemoveDialogType {
  DELETE,
  SAVE,
  ROLLBACK,
  END,
  NONE,
}

export const RemoTabPanel = (props: Props) => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const {
    viewer,
    detailTab,
    currentViewerMode,
    updateProjectDetail,
    getProjectDetail,
    reloadPointCloud,
  } = useContext(ProjectDetailContext);
  const { openSuccess, openWarning, openError } =
    useContext(UseSnackbarContext);

  let { setCallback } = useContext(PollingContext);
  const { projectId } = useParams();

  /*****************************************
    state
  ******************************************/
  const [currentDialog, setCurrentDialog] = useState<ERemoveDialogType>(
    ERemoveDialogType.NONE
  );
  const [timeStamp, setTimeStamp] = useState<string>();
  const [jsonData, setJsonData] = useState<ISelectionData[] | undefined>();
  const [deletedJsonArray, setDeletedJsonArray] = useState<any[]>([]);
  const [disabledReturn, setDisabledReturn] = useState<boolean>(true);
  const {
    countSelection,
    setCountSelection,
    setTotalCount,
    maxCountSelection,
  } = useContext(RemoveContext);
  const [isDeleteInside, setIsDeleteInside] = useState<boolean>(false);
  const [lastCountSelection, setLastCountSelection] = useState<number>(0);

  useEffect(() => {
    if (currentViewerMode !== EViewerMode.POINT_REMOVE) return;
    setCallback(() => getTimestamp);
    startSelection();
    getTimestamp();
    document.addEventListener("pointslimitreached", warnLimit);

    return () => {
      setCallback(() => {});
      viewer.exitCanvasSelection();
      document.removeEventListener("pointslimitreached", warnLimit);
      viewer.abortLoadPointCloud();
      getProjectDetail();
      viewer.poligonIndicesCount = 0;
    };
  }, [currentViewerMode]);

  useEffect(() => {
    setDeletedJsonArray([]);
  }, [currentViewerMode, detailTab]);

  useEffect(() => {
    setDisabledReturn(false);
    getTimestamp();
  }, [detailTab]);

  const confirmPick = () => {
    setCurrentDialog(ERemoveDialogType.DELETE);
    const data = viewer.finishCanvasSelection();
    setTotalCount(viewer.poligonIndicesCount + countSelection);
    setLastCountSelection(countSelection);
    if (data) {
      setJsonData(data);
      const ddata = getDeleteDataStruct(data, true, false);
      const deletedJSONs = [...deletedJsonArray, ddata];
      setDeletedJsonArray(deletedJSONs);
      viewer.applySelectionsToPointCloud(deletedJSONs, "red");
    }
  };

  const getDeleteDataStruct = (
    jsonData: any,
    isDeleteInside: boolean,
    isDeleted: boolean
  ) => {
    return {
      triangles: jsonData,
      isDeleteInside: isDeleteInside,
      isDeleted: isDeleted,
      selectionType: "polygon",
    };
  };

  const cancelPick = () => {
    viewer.cancelCanvasSelection();
  };

  const disabledSave = () => {
    return deletedJsonArray.length <= 0;
  };

  const disabledConfirm = () => {
    return countSelection < 3;
  };

  const disabledCancel = () => {
    return countSelection <= 0;
  };

  const disabledUndo = () => {
    return countSelection <= 0;
  };

  const undoPick = () => {
    viewer.undoCanvasSelection();
  };

  const getTimestamp = () => {
    axios
      .get(
        `${
          config.serverHost
        }/api/v1/project/${projectId}/point-cloud/${FormatUtil.reqStringForPointCloud(
          DETAIL_TAB2POINT_CLOUD_TYPE(detailTab)
        )}/removal`,
        { withCredentials: true }
      )
      .then((res) => {
        setTimeStamp(res.data.time);
        const disabledFlag: boolean = res.data.stateVal;

        if (res.data.hasInit && disabledFlag) {
          setDisabledReturn(false);
        } else {
          setDisabledReturn(true);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const startSelection = () => {
    setCountSelection(0);
    setTotalCount(0);
    viewer.poligonMaxCount = maxCountSelection;
    viewer.exitCanvasSelection();
    viewer.startCanvasSelection(
      () => {},
      () => {},
      (points, count, total) => {
        setCountSelection(count);
        setTotalCount(total);
      }
    );
  };

  const warnLimit = () => {
    openWarning(t("NO_MORE_SELECTIONS"));
  };

  // 簡易点群除去ダイアログ
  const DisplayDialogComponent = () => {
    /*****************************************
      state
    ******************************************/
    const { processIds, updateProcessIds } = useContext(PollingContext);

    /*****************************************
      effect
    ******************************************/
    const onChangeClick = (
      event: React.ChangeEvent<HTMLInputElement>,
      checked: boolean
    ) => {
      const latestData = deletedJsonArray.pop();
      if (latestData) {
        const newData = getDeleteDataStruct(
          latestData.triangles,
          !checked,
          false
        );
        const deletedJSONs = [...deletedJsonArray, newData];
        setDeletedJsonArray(deletedJSONs);
        viewer.applySelectionsToPointCloud(deletedJSONs, "red");
      }
      setIsDeleteInside(checked);
    };

    const statusErrMsg = (resStatus: Common.ProcessingStatus) => {
      const PROCESSING = Common.PROJECT_STATUS_ENUM.PROCESSING;
      if (resStatus.helmert_transformation) {
        openError(t("HELMERT_TRANSFORM") + t("PROCESSING_STATUS_ERROR"));
      } else if (resStatus.coordinate_transformation) {
        openError(t("COORDINATE_PROCESS") + t("PROCESSING_STATUS_ERROR"));
      } else if (resStatus.point_splitting) {
        openError(t("POINT_GROUP_SEGMENTATION") + t("PROCESSING_STATUS_ERROR"));
      } else if (resStatus.remove) {
        openError(t("SIMPLE_POINT_REMOVAL") + t("PROCESSING_STATUS_ERROR"));
      } else if (resStatus.txt_conversion) {
        openError(t("TEXT_CONVERSION") + t("PROCESSING_STATUS_ERROR"));
      }
    };

    const theme = useTheme();

    const customColor = {
      color: theme.palette.base.contrast,
    };

    const customBackground = {
      background: theme.palette.base.opacityMain,
    };

    const customButton = {
      background: theme.palette.primary.main,
      boxShadow: "none",
      "&:hover": {
        background: theme.palette.primary.main,
        boxShadow: "none",
      },
    };

    const CustomCanselButton = styled(Button)({
      background: theme.palette.base.modal,
      boxShadow: "none",
      color: theme.palette.base.contrast,
      "&:hover": {
        background: theme.palette.base.modal,
        color: theme.palette.base.contrast,
        boxShadow: "none",
      },
    });

    const saveDeletion = () => {
      setTotalCount(0);
      if (deletedJsonArray.length > 0) {
        for (const data of deletedJsonArray) {
          for (const triangle of data.triangles) {
            if (triangle.cartesianPoints.length > 0) {
              const offset = viewer.getOffset();

              triangle.centerPosition[0] = -offset.x;
              triangle.centerPosition[1] = -offset.y;
              triangle.centerPosition[2] = -offset.z;
            }
          }
        }
      }

      const body = {
        selectInfo: deletedJsonArray,
        timeStamp: timeStamp,
      };
      axios
        .post(
          `${
            config.serverHost
          }/api/v1/project/${projectId}/point-cloud/${FormatUtil.reqStringForPointCloud(
            DETAIL_TAB2POINT_CLOUD_TYPE(detailTab)
          )}/removal`,
          body,
          { withCredentials: true }
        )
        .then((res) => {
          openSuccess(t("START_POINT_REMOVE"));
          // const updateData =
          //   currentPointCloud === Common.POINT_CLOUD_TYPE.SIMPLE
          //     ? ({
          //         remove_lidar: Common.PROJECT_STATUS_ENUM.COMPLETED,
          //       } as IEnabledUpdateProjectDetail)
          //     : currentPointCloud === Common.POINT_CLOUD_TYPE.SFM
          //     ? ({
          //         remove_sfm: Common.PROJECT_STATUS_ENUM.COMPLETED,
          //       } as IEnabledUpdateProjectDetail)
          //     : ({
          //         remove_helmert: Common.PROJECT_STATUS_ENUM.COMPLETED,
          //       } as IEnabledUpdateProjectDetail);
          // updateProjectDetail(updateData);

          if (detailTab === DETAIL_TAB.SFM) {
            updateProcessIds({
              sfm: res.data.process_id,
              helmert: processIds.helmert,
            } as ProcessIds);
          } else if (DETAIL_TAB.HELMERT) {
            updateProcessIds({
              sfm: processIds.sfm,
              helmert: res.data.process_id,
            } as ProcessIds);
          }
        })
        .catch((err) => {
          switch (err.response.status) {
            case 504:
              openWarning(t("PLS_RELOAD"));
              break;
            case 409:
              openError(t("COULD_NOT_SAVE"));
              break;
            case 429:
              statusErrMsg(err.response.data);
              break;
            default:
              openError(t("POINT_GROUP_REMOVE_FAIL"));
              break;
          }
        })
        .finally(() => {
          getProjectDetail(false);
        });

      setDeletedJsonArray([]);
      viewer.poligonIndicesCount = 0;
    };

    const rollbackDeletion = async () => {
      const body = {
        timeStamp: timeStamp,
      };

      const delUrl = `${
        config.serverHost
      }/api/v1/project/${projectId}/point-cloud/${FormatUtil.reqStringForPointCloud(
        DETAIL_TAB2POINT_CLOUD_TYPE(detailTab)
      )}/removal`;

      // 編集中にする
      if (detailTab === DETAIL_TAB.SFM) {
        const updateData = {
          remove_sfm: Common.PROJECT_STATUS_ENUM.PROCESSING,
        } as IEnabledUpdateProjectDetail;
        updateProjectDetail(updateData);
      } else if (detailTab === DETAIL_TAB.HELMERT) {
        const updateData = {
          remove_helmert: Common.PROJECT_STATUS_ENUM.PROCESSING,
        } as IEnabledUpdateProjectDetail;
        updateProjectDetail(updateData);
      }

      openSuccess(t("START_PROCESSING"));

      await axios
        .delete(delUrl, { withCredentials: true, data: body })
        .then(() => {
          reloadPointCloud();
          getTimestamp();
          openSuccess(t("END_PROCESSING"));
        })
        .catch((err) => {
          switch (err.response.status) {
            case 504:
              openWarning(t("PLS_RELOAD"));
              break;
            case 409:
              openError(t("COULD_NOT_SAVE"));
              break;
            case 429:
              statusErrMsg(err.response.data);
              break;
            default:
              openError(t("POINT_GROUP_REMOVE_FAIL"));
              break;
          }
        })
        .finally(() => {
          getProjectDetail(false);
        });
    };

    const onClickLeftBtn = () => {
      switch (currentDialog) {
        case ERemoveDialogType.DELETE:
          setTotalCount(viewer.poligonIndicesCount);
          deletedJsonArray.pop();
          viewer.applySelectionsToPointCloud(deletedJsonArray, "red");
          startSelection();
          break;
        case ERemoveDialogType.END:
          startSelection();
          break;
        default:
          break;
      }
      setCurrentDialog(ERemoveDialogType.NONE);
      // removeProps.onCloseDialog();
    };

    const onClickRightBtn = () => {
      switch (currentDialog) {
        case ERemoveDialogType.DELETE:
          const deletedJSONs = deletedJsonArray.slice();
          for (const dj of deletedJSONs) {
            dj.isDeleted = true;
          }
          viewer.poligonIndicesCount += lastCountSelection;
          setTotalCount(viewer.poligonIndicesCount);

          setDeletedJsonArray(deletedJSONs);
          viewer.applySelectionsToPointCloud(deletedJSONs, "red");
          setIsDeleteInside(false);

          setJsonData(null); // init
          startSelection();
          break;
        case ERemoveDialogType.SAVE:
          saveDeletion();
          break;
        case ERemoveDialogType.ROLLBACK:
          rollbackDeletion();
          break;
        case ERemoveDialogType.END:
          // removeProps.end();
          // removeProps.onCloseDialog();
          viewer.exitCanvasSelection();
          break;
        default:
          break;
      }
      setCurrentDialog(ERemoveDialogType.NONE);
    };

    const DialogContent = () => {
      switch (currentDialog) {
        case ERemoveDialogType.DELETE:
          return (
            <>
              <DialogTitle
                className="dialog-text"
                sx={{ padding: "12px 20px" }}
              >
                {t("DELETE_SELECT_POINT")}
              </DialogTitle>
              <DialogActions
                sx={{
                  padding: "0px",
                  display: "flex",
                  justifyContent: "left",
                  margin: "0px 40px",
                }}
              >
                <Checkbox checked={isDeleteInside} onChange={onChangeClick} />{" "}
                {t("INVERT_SELECT")}
              </DialogActions>
            </>
          );
        case ERemoveDialogType.SAVE:
          return (
            <>
              <DialogTitle className="dialog-text">
                {t("SAVE_DATA_POINT_CLOUD")}
              </DialogTitle>
            </>
          );
        case ERemoveDialogType.ROLLBACK:
          return (
            <>
              <DialogTitle className="dialog-text">
                {t("RETURN_POINT_IMMEDIATELY")}
              </DialogTitle>
            </>
          );
        case ERemoveDialogType.END:
          return (
            <>
              <DialogTitle className="dialog-text">
                {t("END_POINT_REMOVE")}
              </DialogTitle>
            </>
          );
        default:
          return <></>;
      }
    };

    const rightBtnTxt = () => {
      switch (currentDialog) {
        case ERemoveDialogType.DELETE:
          return t("EXECUTION");
        case ERemoveDialogType.SAVE:
          return t("SAVE");
        case ERemoveDialogType.ROLLBACK:
          return t("EXECUTION");
        case ERemoveDialogType.END:
          return t("END");
        default:
          return;
      }
    };

    return (
      <>
        {/* <Dialog open={currentDialog !== ERemoveDialogType.NONE || removeProps.currentDialog === EDialogType.POINT_REMOVE} PaperProps={{ className: 'remove-view7', style: customBackground }}> */}
        <Dialog
          open={currentDialog !== ERemoveDialogType.NONE}
          PaperProps={{ className: "remove-view7", style: customBackground }}
        >
          {DialogContent()}
          <DialogActions className="dialog-group">
            <CustomCanselButton
              className="pcv-btn-comm pcv-btn1"
              variant="contained"
              onClick={onClickLeftBtn}
            >
              {t("CANCEL")}
            </CustomCanselButton>
            <Button
              className="pcv-btn-comm pcv-btn2"
              variant="contained"
              color="primary"
              onClick={onClickRightBtn}
              style={customButton}
            >
              {rightBtnTxt()}
            </Button>
          </DialogActions>
        </Dialog>
        {/* <ProcessCompletedDialog
          open={openSfm}
          result={result}
          process={process}
          processId={processId}
          handleClickClose={handleClickCloseSfm}
        />
        <ProcessCompletedDialog
          open={openHelmert}
          result={result}
          process={process}
          processId={processId}
          handleClickClose={handleClickCloseHelmert}
        /> */}
      </>
    );
  };

  return (
    <>
      <Q3DTabPanel
        value={EViewerMode.POINT_REMOVE}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: "var(--space-space--4, 4px)",
          width: props.width,
          paddingLeft: "4px",
        }}
      >
        <Q3DIconButton
          title={t("RETURN_INITIAL")}
          titleType={i18n.language === "ja" ? "both" : "tooltip"}
          icon={<RestoreIcon />}
          height={"36px"}
          onClick={() => {
            setCurrentDialog(ERemoveDialogType.ROLLBACK);
          }}
          disabled={disabledReturn}
          // sx={{
          //   minWidth: "40px",
          //   background: theme.palette.base.ymdBackground,
          //   color: "#FFFFFF",
          //   "&:hover": {
          //     background: "#736CED",
          //   },
          // }}
          sx={{ minWidth: "40px" }}
          type="default"
        />
        <Q3DIconButton
          title={t("UNMARK")}
          titleType={i18n.language === "ja" ? "both" : "tooltip"}
          icon={<ReplyIcon />}
          height={"36px"}
          onClick={undoPick}
          disabled={disabledUndo()}
          sx={{ minWidth: "40px" }}
          type="warning"
        />
        <Q3DIconButton
          title={t("CANCEL")}
          titleType={i18n.language === "ja" ? "both" : "tooltip"}
          icon={<CloseIcon />}
          height={"36px"}
          onClick={cancelPick}
          disabled={disabledCancel()}
          sx={{ minWidth: "40px" }}
          type="error"
        />
        <Q3DIconButton
          title={t("CONFIRM")}
          titleType={i18n.language === "ja" ? "both" : "tooltip"}
          icon={<CheckIcon />}
          height={"36px"}
          onClick={confirmPick}
          disabled={disabledConfirm()}
          type="default"
          sx={{ minWidth: "40px" }}
          // sx={{
          //   minWidth: "40px",
          //   background: theme.palette.base.ymdBackground,
          //   color: "#FFFFFF",
          //   "&:hover": {
          //     background: "#736CED",
          //   },
          // }}
        />
        <Q3DIconButton
          title={t("SAVE")}
          titleType={i18n.language === "ja" ? "both" : "tooltip"}
          icon={<Save />}
          height={"36px"}
          onClick={() => {
            setCurrentDialog(ERemoveDialogType.SAVE);
          }}
          disabled={disabledSave()}
          sx={{ minWidth: "40px" }}
          type="default"
          // sx={{
          //   minWidth: "40px",
          //   background: theme.palette.base.ymdBackground,
          //   color: "#FFFFFF",
          //   "&:hover": {
          //     background: "#736CED",
          //   },
          // }}
        />
      </Q3DTabPanel>
      <DisplayDialogComponent />
    </>
  );
};
